<div class="terminal-log">
  <!-- Header -->
  <div class="row mb-4 align-items-center">
    <div class="col-md-5">
      <h4>{{ 'TERMINAL_LOG.TITLE' | translate }}</h4>
      <p class="text-muted">{{ 'TERMINAL_LOG.SUBTITLE' | translate }}</p>
    </div>
    <div class="col-md-7">
      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <span class="text-muted me-2" *ngIf="!isLoading">
          {{ totalItems }} {{ 'TERMINAL_LOG.ENTRIES_FOUND' | translate }}
        </span>

        <!-- Auto-refresh controls -->
        <div class="auto-refresh-bar d-flex align-items-center gap-2">
          <nb-toggle
            [(checked)]="autoRefreshEnabled"
            (checkedChange)="toggleAutoRefresh()"
            status="primary">
            {{ 'TERMINAL_LOG.AUTO_REFRESH' | translate }}
          </nb-toggle>

          <nb-select
            [(selected)]="refreshIntervalSec"
            (selectedChange)="onRefreshIntervalChange()"
            size="small"
            [placeholder]="'TERMINAL_LOG.INTERVAL' | translate">
            <nb-option [value]="15">15 s</nb-option>
            <nb-option [value]="30">30 s</nb-option>
            <nb-option [value]="60">1 min</nb-option>
            <nb-option [value]="120">2 min</nb-option>
            <nb-option [value]="300">5 min</nb-option>
          </nb-select>

          <span *ngIf="autoRefreshEnabled" class="text-muted small text-nowrap">
            {{ 'TERMINAL_LOG.NEXT_IN' | translate }} {{ countdown }}s
          </span>

          <button
            class="btn btn-outline-secondary btn-sm text-nowrap"
            (click)="loadLogs()">
            <nb-icon icon="refresh-outline"></nb-icon>
            {{ 'TERMINAL_LOG.REFRESH_NOW' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-end g-3">
        <div class="col-md-2">
          <label class="form-label">{{ 'TERMINAL_LOG.FILTER_DATE_FROM' | translate }}</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="dateFrom"
            (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'TERMINAL_LOG.FILTER_DATE_TO' | translate }}</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="dateTo"
            (change)="onFilterChange()">
        </div>
        <div class="col-md-2">
          <label class="form-label">{{ 'TERMINAL_LOG.FILTER_OUTCOME' | translate }}</label>
          <select class="form-select" [(ngModel)]="selectedOutcome" (change)="onFilterChange()">
            <option *ngFor="let opt of outcomeOptions" [value]="opt.value">
              {{ opt.labelKey | translate }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'TERMINAL_LOG.FILTER_SEARCH' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="searchText"
            [placeholder]="'TERMINAL_LOG.SEARCH_PLACEHOLDER' | translate"
            (keyup.enter)="onFilterChange()">
        </div>
        <div class="col-md-3 d-flex flex-column gap-2">
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="orderSaveFailedOnly"
              [(ngModel)]="orderSaveFailedOnly"
              (change)="onFilterChange()">
            <label class="form-check-label fw-semibold text-danger" for="orderSaveFailedOnly">
              {{ 'TERMINAL_LOG.FILTER_ORDER_SAVE_FAILED' | translate }}
            </label>
          </div>
          <button class="btn btn-outline-secondary w-100" (click)="resetFilters()">
            {{ 'TERMINAL_LOG.RESET_FILTERS' | translate }}
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Table -->
  <nb-card>
    <nb-card-body class="p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>{{ 'TERMINAL_LOG.COL_TIMESTAMP' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_TERMINAL' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_OUTCOME' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_AMOUNT' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_CARD' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_AUTH_CODE' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_DECLINE_REASON' | translate }}</th>
              <th>{{ 'TERMINAL_LOG.COL_LINKED_ORDER' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let log of logs; trackBy: trackByLogId"
              [class.order-save-failed-row]="isChargedNotRecorded(log)"
              [class.approved-unlinked-row]="isApprovedUnlinked(log)"
              [class.reconciled-row]="isReconciled(log)"
              [nbTooltip]="isChargedNotRecorded(log) ? ('TERMINAL_LOG.ORDER_SAVE_FAILED_TOOLTIP' | translate) : (isApprovedUnlinked(log) ? ('TERMINAL_LOG.APPROVED_UNLINKED_TOOLTIP' | translate) : (isReconciled(log) ? ('TERMINAL_LOG.RECONCILED_TOOLTIP' | translate) : ''))">
              <td class="text-nowrap">
                <span *ngIf="isChargedNotRecorded(log)" class="order-save-failed-icon me-1" nbTooltip="{{ 'TERMINAL_LOG.ORDER_SAVE_FAILED_TOOLTIP' | translate }}">
                  <nb-icon icon="alert-triangle-outline"></nb-icon>
                </span>
                <span *ngIf="isApprovedUnlinked(log)" class="approved-unlinked-icon me-1" nbTooltip="{{ 'TERMINAL_LOG.APPROVED_UNLINKED_TOOLTIP' | translate }}">
                  <nb-icon icon="alert-circle-outline"></nb-icon>
                </span>
                <span *ngIf="isReconciled(log)" class="reconciled-icon me-1" nbTooltip="{{ 'TERMINAL_LOG.RECONCILED_TOOLTIP' | translate }}">
                  <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
                </span>
                {{ log.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}
              </td>
              <td>{{ formatTerminal(log) }}</td>
              <td>
                <span class="badge" [ngClass]="getOutcomeBadgeClass(log.outcome)">
                  {{ getOutcomeLabelKey(log.outcome) | translate }}
                </span>
                <span *ngIf="isChargedNotRecorded(log)" class="badge bg-danger ms-1">
                  {{ 'TERMINAL_LOG.ORDER_SAVE_FAILED_BADGE' | translate }}
                </span>
                <span *ngIf="isApprovedUnlinked(log)" class="badge bg-warning text-dark ms-1">
                  {{ 'TERMINAL_LOG.APPROVED_UNLINKED_BADGE' | translate }}
                </span>
                <span *ngIf="isReconciled(log)" class="badge reconciled-badge ms-1">
                  <nb-icon icon="edit-2-outline" class="me-1"></nb-icon>
                  {{ 'TERMINAL_LOG.RECONCILED_BADGE' | translate }}
                </span>
              </td>
              <td class="text-nowrap">{{ formatAmount(log) }}</td>
              <td class="font-monospace small">{{ formatCard(log) }}</td>
              <td class="font-monospace small">{{ log.authCode || '—' }}</td>
              <td class="small decline-reason-cell">{{ formatDeclineReason(log) }}</td>
              <td>
                <button
                  *ngIf="getLinkedOrder(log) as linkedOrder"
                  class="btn btn-link btn-sm p-0"
                  (click)="navigateToLinkedOrder(linkedOrder); $event.stopPropagation()">
                  {{ linkedOrder.orderNumber }}
                  <span class="badge bg-light text-dark border ms-1">{{ linkedOrder.status }}</span>
                </button>
                <span *ngIf="!getLinkedOrder(log)" class="text-muted">—</span>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-outline-primary"
                  (click)="viewLogDetails(log)"
                  [nbTooltip]="'TERMINAL_LOG.VIEW_DETAIL' | translate">
                  <nb-icon icon="eye-outline"></nb-icon>
                  {{ 'TERMINAL_LOG.VIEW' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="text-center p-4">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-2 text-muted">{{ 'TERMINAL_LOG.LOADING' | translate }}</p>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && errorMessage" class="text-center p-4">
        <nb-icon icon="alert-circle-outline" class="text-danger" style="font-size: 2rem;"></nb-icon>
        <p class="mt-2 text-danger">{{ errorMessage | translate }}</p>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadLogs()">
          {{ 'TERMINAL_LOG.TRY_AGAIN' | translate }}
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !errorMessage && logs.length === 0" class="text-center p-4">
        <nb-icon icon="credit-card-outline" style="font-size: 2.5rem;" class="text-muted mb-2"></nb-icon>
        <h5>{{ 'TERMINAL_LOG.NO_DATA_TITLE' | translate }}</h5>
        <p class="text-muted">{{ 'TERMINAL_LOG.NO_DATA_HINT' | translate }}</p>
      </div>

      <!-- Pagination -->
      <div
        *ngIf="!isLoading && totalPages > 1"
        class="d-flex justify-content-between align-items-center p-3 border-top">
        <div>
          <span class="text-muted">
            {{ 'TERMINAL_LOG.SHOWING' | translate }}
            {{ (currentPage - 1) * pageSize + 1 }}
            {{ 'TERMINAL_LOG.TO' | translate }}
            {{ Math.min(currentPage * pageSize, totalItems) }}
            {{ 'TERMINAL_LOG.OF' | translate }} {{ totalItems }}
          </span>
        </div>
        <div>
          <button
            class="btn btn-outline-secondary me-2"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)">
            {{ 'TERMINAL_LOG.PREVIOUS' | translate }}
          </button>
          <span class="me-2">{{ 'TERMINAL_LOG.PAGE' | translate }} {{ currentPage }} {{ 'TERMINAL_LOG.OF' | translate }} {{ totalPages }}</span>
          <button
            class="btn btn-outline-secondary"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)">
            {{ 'TERMINAL_LOG.NEXT' | translate }}
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- Detail Modal -->
<nb-card *ngIf="showLogDetails" class="modal-overlay" [class.modal-wide]="canShowReconcilePanel() || isReconciled(selectedLog)">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-3 flex-wrap">
      <h5 class="mb-0">{{ 'TERMINAL_LOG.DETAIL_TITLE' | translate }}</h5>
      <span *ngIf="selectedLog" class="badge" [ngClass]="getOutcomeBadgeClass(selectedLog.outcome)">
        {{ getOutcomeLabelKey(selectedLog.outcome) | translate }}
      </span>
      <span *ngIf="isChargedNotRecorded(selectedLog)" class="badge bg-danger">
        {{ 'TERMINAL_LOG.ORDER_SAVE_FAILED_BADGE' | translate }}
      </span>
      <span *ngIf="isApprovedUnlinked(selectedLog)" class="badge bg-warning text-dark">
        {{ 'TERMINAL_LOG.APPROVED_UNLINKED_BADGE' | translate }}
      </span>
      <span *ngIf="isReconciled(selectedLog)" class="badge reconciled-badge">
        <nb-icon icon="edit-2-outline" class="me-1"></nb-icon>
        {{ 'TERMINAL_LOG.RECONCILED_BADGE' | translate }}
      </span>
      <span *ngIf="selectedLog?.createdAt" class="text-muted small">
        {{ selectedLog.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}
      </span>
    </div>
    <button class="btn btn-ghost" (click)="closeLogDetails()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="selectedLog" class="modal-body">
    <div *ngIf="loadingDetail" class="text-center p-3">
      <nb-spinner size="medium"></nb-spinner>
      <p class="mt-2 text-muted small">{{ 'TERMINAL_LOG.LOADING_DETAIL' | translate }}</p>
    </div>

    <div *ngIf="!loadingDetail">
      <div *ngIf="isChargedNotRecorded(selectedLog)" class="alert alert-danger d-flex align-items-start gap-2 mb-4">
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        <div>
          <strong>{{ 'TERMINAL_LOG.ORDER_SAVE_FAILED_BADGE' | translate }}</strong>
          <p class="mb-0 small" *ngIf="selectedLog.orderSaveError">{{ selectedLog.orderSaveError }}</p>
        </div>
      </div>

      <div *ngIf="isApprovedUnlinked(selectedLog)" class="alert alert-warning d-flex align-items-start gap-2 mb-4">
        <nb-icon icon="alert-circle-outline"></nb-icon>
        <div>
          <strong>{{ 'TERMINAL_LOG.APPROVED_UNLINKED_BADGE' | translate }}</strong>
          <p class="mb-0 small">{{ 'TERMINAL_LOG.APPROVED_UNLINKED_HINT' | translate }}</p>
        </div>
      </div>

      <div *ngIf="isReconciled(selectedLog)" class="alert alert-reconciled d-flex align-items-start gap-2 mb-4">
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        <div>
          <strong>{{ 'TERMINAL_LOG.RECONCILED_BADGE' | translate }}</strong>
          <p class="mb-0 small">{{ 'TERMINAL_LOG.RECONCILED_DETAIL_HINT' | translate }}</p>
          <p class="mb-0 small mt-1" *ngIf="selectedLog.reconciliation?.note">
            <strong>{{ 'TERMINAL_LOG.RECONCILE_NOTE' | translate }}:</strong> {{ selectedLog.reconciliation.note }}
          </p>
          <p class="mb-0 small mt-1 text-warning-emphasis" *ngIf="selectedLog.reconciliation?.amountMismatchWarning">
            {{ selectedLog.reconciliation.amountMismatchWarning }}
          </p>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-md-6">
          <h6 class="section-label">{{ 'TERMINAL_LOG.DETAIL_INFO' | translate }}</h6>
          <p><strong>{{ 'TERMINAL_LOG.COL_TERMINAL' | translate }}:</strong>
            <span class="ms-2">{{ formatTerminal(selectedLog) }}</span>
          </p>
          <p><strong>{{ 'TERMINAL_LOG.COL_AMOUNT' | translate }}:</strong>
            <span class="ms-2">{{ formatAmount(selectedLog) }}</span>
          </p>
          <p><strong>{{ 'TERMINAL_LOG.COL_CARD' | translate }}:</strong>
            <span class="ms-2 font-monospace small">{{ formatCard(selectedLog) }}</span>
          </p>
          <p><strong>{{ 'TERMINAL_LOG.COL_AUTH_CODE' | translate }}:</strong>
            <span class="ms-2 font-monospace small">{{ selectedLog.authCode || '—' }}</span>
          </p>
        </div>
        <div class="col-md-6">
          <h6 class="section-label">{{ 'TERMINAL_LOG.DETAIL_PAYMENT' | translate }}</h6>
          <p><strong>{{ 'TERMINAL_LOG.COL_DECLINE_REASON' | translate }}:</strong>
            <span class="ms-2">{{ formatDeclineReason(selectedLog) }}</span>
          </p>
          <p *ngIf="selectedLog.vivaEventId"><strong>{{ 'TERMINAL_LOG.VIVA_EVENT_ID' | translate }}:</strong>
            <span class="ms-2">{{ selectedLog.vivaEventId }}</span>
          </p>
          <p><strong>{{ 'TERMINAL_LOG.COL_LINKED_ORDER' | translate }}:</strong>
            <span class="ms-2" *ngIf="getLinkedOrder(selectedLog) as linkedOrder">
              <button class="btn btn-link btn-sm p-0" (click)="navigateToLinkedOrder(linkedOrder)">
                {{ linkedOrder.orderNumber }}
                <span class="badge bg-light text-dark border ms-1">{{ linkedOrder.status }}</span>
              </button>
            </span>
            <span *ngIf="!getLinkedOrder(selectedLog)" class="text-muted ms-2">—</span>
          </p>
        </div>
      </div>

      <div *ngIf="canShowReconcilePanel()" class="reconcile-panel mb-4">
        <h6 class="section-label">{{ 'TERMINAL_LOG.RECONCILE_TITLE' | translate }}</h6>
        <p class="text-muted small">{{ 'TERMINAL_LOG.RECONCILE_SUBTITLE' | translate }}</p>

        <div class="mb-3">
          <label class="form-label fw-semibold">{{ 'TERMINAL_LOG.RECONCILE_NOTE' | translate }} <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="reconciliationNote"
            [placeholder]="'TERMINAL_LOG.RECONCILE_NOTE_PLACEHOLDER' | translate"></textarea>
          <div class="form-text">{{ 'TERMINAL_LOG.RECONCILE_NOTE_HINT' | translate }}</div>
        </div>

        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <button
              type="button"
              class="nav-link"
              [class.active]="reconcileMode === 'manual'"
              (click)="setReconcileMode('manual')">
              {{ 'TERMINAL_LOG.RECONCILE_MODE_MANUAL' | translate }}
            </button>
          </li>
          <li class="nav-item">
            <button
              type="button"
              class="nav-link"
              [class.active]="reconcileMode === 'link'"
              (click)="setReconcileMode('link')">
              {{ 'TERMINAL_LOG.RECONCILE_MODE_LINK' | translate }}
            </button>
          </li>
        </ul>

        <div *ngIf="reconcileMode === 'link'">
          <div class="row g-2 mb-3">
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="orderSearchQuery"
                [placeholder]="'TERMINAL_LOG.RECONCILE_ORDER_SEARCH_PLACEHOLDER' | translate"
                (keyup.enter)="searchOrdersForReconcile()">
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-outline-primary w-100"
                (click)="searchOrdersForReconcile()"
                [disabled]="orderSearchLoading">
                <span *ngIf="orderSearchLoading" class="spinner-border spinner-border-sm me-1"></span>
                {{ 'TERMINAL_LOG.RECONCILE_SEARCH_ORDERS' | translate }}
              </button>
            </div>
          </div>

          <div *ngIf="orderSearchResults.length > 0" class="table-responsive mb-3">
            <table class="table table-sm table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th></th>
                  <th>{{ 'TERMINAL_LOG.RECONCILE_COL_ORDER' | translate }}</th>
                  <th>{{ 'TERMINAL_LOG.RECONCILE_COL_CUSTOMER' | translate }}</th>
                  <th>{{ 'TERMINAL_LOG.RECONCILE_COL_AMOUNT' | translate }}</th>
                  <th>{{ 'TERMINAL_LOG.RECONCILE_COL_DATE' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let order of orderSearchResults"
                  [class.table-primary]="selectedOrderId === order._id"
                  (click)="selectOrderForReconcile(order)"
                  style="cursor: pointer;">
                  <td>
                    <input type="radio" name="reconcileOrder" [checked]="selectedOrderId === order._id">
                  </td>
                  <td>{{ order.orderNumber }}</td>
                  <td>{{ formatOrderCustomer(order) }}</td>
                  <td>
                    {{ formatOrderAmount(order) }}
                    <span *ngIf="orderAmountMismatch(order)" class="badge bg-warning text-dark ms-1">
                      {{ 'TERMINAL_LOG.RECONCILE_AMOUNT_MISMATCH' | translate }}
                    </span>
                  </td>
                  <td>{{ order.orderDate | date:'dd/MM/yyyy HH:mm' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="reconcileMode === 'manual'">
          <div *ngIf="loadingBasketPrefill" class="text-muted small mb-2">
            <span class="spinner-border spinner-border-sm me-1"></span>
            {{ 'TERMINAL_LOG.RECONCILE_LOADING_PREFILL' | translate }}
          </div>
          <p *ngIf="!loadingBasketPrefill && basketPrefillSource" class="text-muted small mb-2">
            {{ basketPrefillSource | translate }}
          </p>

          <div class="table-responsive mb-2">
            <table class="table table-sm table-bordered align-middle">
              <thead class="table-light">
                <tr>
                  <th>{{ 'TERMINAL_LOG.RECONCILE_COL_PRODUCT' | translate }}</th>
                  <th style="width: 110px;">{{ 'TERMINAL_LOG.RECONCILE_COL_QTY' | translate }}</th>
                  <th style="width: 130px;">{{ 'TERMINAL_LOG.RECONCILE_COL_UNIT_PRICE' | translate }}</th>
                  <th style="width: 120px;">{{ 'TERMINAL_LOG.RECONCILE_COL_LINE_TOTAL' | translate }}</th>
                  <th style="width: 60px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of manualItems; let i = index">
                  <td>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="item.productName">
                  </td>
                  <td>
                    <input type="number" min="1" class="form-control form-control-sm" [(ngModel)]="item.quantity">
                  </td>
                  <td>
                    <input type="number" min="0" step="0.01" class="form-control form-control-sm" [(ngModel)]="item.unitPrice">
                  </td>
                  <td class="text-end">{{ formatAmount({ amount: (item.quantity || 0) * (item.unitPrice || 0), currency: selectedLog.currency }) }}</td>
                  <td>
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeManualItemRow(i)">
                      <nb-icon icon="trash-2-outline"></nb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-active fw-semibold">
                  <td colspan="3" class="text-end">{{ 'TERMINAL_LOG.RECONCILE_ITEMS_TOTAL' | translate }}</td>
                  <td class="text-end">
                    {{ formatAmount({ amount: getManualItemsTotal(), currency: selectedLog.currency }) }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="5" class="small">
                    <span>{{ 'TERMINAL_LOG.RECONCILE_TERMINAL_AMOUNT' | translate }}: {{ formatAmount(selectedLog) }}</span>
                    <span *ngIf="manualItemsTotalMismatch()" class="badge bg-warning text-dark ms-2">
                      {{ 'TERMINAL_LOG.RECONCILE_AMOUNT_MISMATCH' | translate }}
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="addManualItemRow()">
            <nb-icon icon="plus-outline"></nb-icon>
            {{ 'TERMINAL_LOG.RECONCILE_ADD_ITEM' | translate }}
          </button>
        </div>

        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-reconcile"
            (click)="submitReconcile()"
            [disabled]="isReconcileSubmitDisabled()">
            <span *ngIf="submittingReconcile" class="spinner-border spinner-border-sm me-1"></span>
            <nb-icon *ngIf="!submittingReconcile" icon="link-2-outline" class="me-1"></nb-icon>
            {{ 'TERMINAL_LOG.RECONCILE_SUBMIT' | translate }}
          </button>
        </div>
      </div>

      <h6 class="section-label">{{ 'TERMINAL_LOG.RAW_REQUEST' | translate }}</h6>
      <pre class="json-block">{{ prettyJson(selectedLog.rawRequest) }}</pre>

      <h6 class="section-label mt-3">{{ 'TERMINAL_LOG.RAW_RESPONSE' | translate }}</h6>
      <pre class="json-block">{{ prettyJson(selectedLog.rawResponse) }}</pre>
    </div>
  </nb-card-body>
</nb-card>
